
interface LogoProps {
  className?: string;
}

const Logo = ({ className = '' }: LogoProps) => {
  return (
    <div 
      className={`text-2xl font-bold text-blue-600 ${className}`}
      style={{ fontFamily: '"Pacifico", serif' }}
    >
      SEO Vektor
    </div>
  );
};

export default Logo;
